import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { 
  Gamepad2, Trophy, BookOpen, Zap, Settings, 
  ChevronDown, Award, Layout, Video, Info, Play
} from 'lucide-react';
import { useAuth, useTooltip } from '@app/providers';

const Navigation = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const navRef = useRef(null);
  const { showTooltip, hideTooltip } = useTooltip();
  const { user, isAuthenticated } = useAuth();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setActiveDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const renderDropdown = (id, label, icon, items) => {
    const isVisible = activeDropdown === id;
    return (
      <li className="nav-item dropdown-container">
        <button 
          className={`nav-link ${isVisible ? 'active' : ''}`}
          onClick={() => setActiveDropdown(isVisible ? null : id)}
          onMouseEnter={() => showTooltip(label, `Открыть ${label}`, 'Нажмите для выбора')}
          onMouseLeave={hideTooltip}
        >
          <span className="nav-icon">{icon}</span>
          <span className="nav-text">{label}</span>
          <ChevronDown size={12} className={`nav-arrow ${isVisible ? 'open' : ''}`} />
        </button>

        <div className={`dropdown-wrapper ${isVisible ? 'visible' : ''}`}>
          <ul className="dropdown-menu">
            {items.map((item, idx) => (
              <li key={idx}>
                <Link
                  to={item.path}
                  className="dropdown-link"
                  onClick={() => setActiveDropdown(null)}
                  onMouseEnter={() => showTooltip(item.label, item.desc || '', 'Перейти')}
                  onMouseLeave={hideTooltip}
                >
                  <span className="dropdown-icon">{item.icon}</span>
                  <span className="dropdown-label">{item.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </li>
    );
  };

  const challengeItems = [
    { path: '/challenge/start', label: 'НАЧАТЬ ЧЕЛЛЕНДЖ', icon: <Play size={16} />, desc: 'Выбор режима и старт' },
    { path: '/winners', label: 'ПОБЕДИТЕЛИ', icon: <Trophy size={16} />, desc: 'Доска почёта' },
  ];
  if (isAuthenticated) {
    challengeItems.push({ path: '/my-challenges', label: 'МОИ ЧЕЛЛЕНДЖИ', icon: <Gamepad2 size={16} />, desc: 'Ваш прогресс' });
  }

  const faqItems = [
    { path: '/rules', label: 'ПРАВИЛА', icon: <BookOpen size={16} />, desc: 'Регламент' },
    { path: '/bonus', label: 'БОНУСЫ', icon: <Zap size={16} />, desc: 'Система наград' },
    { path: '/streamers', label: 'ДЛЯ СТРИМЕРОВ', icon: <Video size={16} />, desc: 'Инструкции' },
  ];

  const settingsItems = isAuthenticated ? [
    { path: '/settings', label: 'ВИДЖЕТЫ', icon: <Layout size={16} />, desc: 'Настройка OBS' },
    { path: '/integrations', label: 'ИНТЕГРАЦИИ', icon: <Settings size={16} />, desc: 'Discord & Twitch' },
    { path: '/achievements', label: 'ДОСТИЖЕНИЯ', icon: <Award size={16} />, desc: 'Ваши награды' },
  ] : [];

  return (
    <nav className="header-nav-container" ref={navRef}>
      <ul className="nav-menu">
        {renderDropdown('challenges', 'ЧЕЛЛЕНДЖИ', <Gamepad2 size={18} />, challengeItems)}
        {renderDropdown('faq', 'FAQ', <Info size={18} />, faqItems)}
        {isAuthenticated && renderDropdown('settings', 'НАСТРОЙКИ', <Settings size={18} />, settingsItems)}
      </ul>
    </nav>
  );
};

export default Navigation;
